import { LABELS } from "./constants";

/** カラム情報デフォルト */
export const columnDefinitionsBase = [
  {
    id: "applicationNo",
    header: LABELS.APPLICATION_NO,
  },
  {
    id: "companyName",
    header: LABELS.COMPANY_NAME,
  },
  {
    id: "merchantsName",
    header: LABELS.MERCHANTS_NAME,
  },
  {
    id: "applicationStatusCodes",
    header: LABELS.APPLICATION_STATUS_TITLE,
  },
  {
    id: "applicationDetailStatusCodes",
    header: LABELS.APPLICATION_STATUS_DETAILS,
  },
  {
    id: "applicationDate",
    header: LABELS.APPLICATION_START_DATE,
  },
  {
    id: "fixedTime",
    header: LABELS.ANSWER_START_TIME,
  },
  {
    id: "applicationTypeCode",
    header: LABELS.APPLICATION_TYPE,
  },
  {
    id: "serviceName",
    header: LABELS.SERVICE_NAME,
  },
  {
    id: "contractType",
    header: LABELS.CONTRACT_STATUS,
  },
  {
    id: "contractRoute",
    header: LABELS.CONTRACT_ROUTE,
  },
  {
    id: "particularRateFlag",
    header: LABELS.PARTICULAR_RATE_FLAG,
  },
];

/** ドコモ管理者と業務担当のみ */
export const columnDefinitionsBaseApply = [
  {
    id: "applicationNo",
    header: LABELS.APPLICATION_NO,
  },
  {
    id: "companyName",
    header: LABELS.COMPANY_NAME,
  },
  {
    id: "merchantsName",
    header: LABELS.MERCHANTS_NAME,
  },
  {
    id: "applicationStatusCodes",
    header: LABELS.APPLICATION_STATUS_TITLE,
  },
  {
    id: "applicationDetailStatusCodes",
    header: LABELS.APPLICATION_STATUS_DETAILS,
  },
  {
    id: "applicationDate",
    header: LABELS.APPLICATION_START_DATE,
  },
  {
    id: "fixedTime",
    header: LABELS.ANSWER_START_TIME,
  },
  {
    id: "applicationTypeCode",
    header: LABELS.APPLICATION_TYPE,
  },
  {
    id: "applicationFormType",
    header: LABELS.APPLICATION_FORM_TYPE,
  },
  {
    id: "serviceName",
    header: LABELS.SERVICE_NAME,
  },
  {
    id: "contractType",
    header: LABELS.CONTRACT_STATUS,
  },
  {
    id: "contractRoute",
    header: LABELS.CONTRACT_ROUTE,
  },
  {
    id: "particularRateFlag",
    header: LABELS.PARTICULAR_RATE_FLAG,
  },
  {
    id: "merchantAnswered",
    header: LABELS.MERCHANT_ANSWERED,
  },
];

/** ドコモユーザ以外 */
export const columnDefinitionsBaseNotDocomo = [
  {
    id: "applicationNo",
    header: LABELS.APPLICATION_NO,
  },
  {
    id: "companyName",
    header: LABELS.COMPANY_NAME,
  },
  {
    id: "merchantsName",
    header: LABELS.MERCHANTS_NAME,
  },
  {
    id: "applicationStatusCodes",
    header: LABELS.APPLICATION_STATUS_TITLE,
  },
  {
    id: "applicationDate",
    header: LABELS.APPLICATION_START_DATE,
  },
  {
    id: "fixedTime",
    header: LABELS.ANSWER_START_TIME,
  },
  {
    id: "applicationTypeCode",
    header: LABELS.APPLICATION_TYPE,
  },
  {
    id: "serviceName",
    header: LABELS.SERVICE_NAME,
  },
  {
    id: "contractType",
    header: LABELS.CONTRACT_STATUS,
  },
  {
    id: "contractRoute",
    header: LABELS.CONTRACT_ROUTE,
  },
];
